import { render, staticRenderFns } from "./StockOpname.vue?vue&type=template&id=bf4fc802&scoped=true"
import script from "./StockOpname.vue?vue&type=script&lang=js"
export * from "./StockOpname.vue?vue&type=script&lang=js"
import style0 from "./StockOpname.vue?vue&type=style&index=0&id=bf4fc802&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf4fc802",
  null
  
)

export default component.exports